<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$allLabel('lists')" icon="menu" :directory="$t('lists')">
            <app-default-button
                :url="apiUrl.addNew"
                :title="$addLabel('list')"
                v-if="$can('create_lists')"
            />
        </app-page-top-section>

        <app-table
            id="list-table"
            :options="options"
            @action="triggerAction"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('list-table')"
            @cancelled="cancelled"
        />

        <app-confirmation-modal
            v-if="removeDuplicatesModalActive"
            modal-id="remove-duplicates-modal"
            :title="$t('remove_duplicates')"
            :message="$t('remove_duplicates_confirmation')"
            modal-class="warning"
            icon="alert-triangle"
            :loading="removeDuplicatesLoading"
            @confirmed="confirmRemoveDuplicates"
            @cancelled="removeDuplicatesModalActive = false"
        />

        <app-duplicates-modal
            v-if="showDuplicatesModalActive"
            :url="`${lists}/${showDuplicatesListId}/show-duplicates`"
            @close="showDuplicatesModalActive = false"
            @remove-duplicates="showDuplicatesModalActive = false; removeDuplicatesListId = showDuplicatesListId; removeDuplicatesModalActive = true;"
        />
    </div>
</template>

<script>
    import {list_create, list_view, lists} from "../../../config/apiUrl";
    import {axiosPost} from "../../../Helpers/AxiosHelper";
    import ListsMixin from "../../DataTable/DataTableMixins/ListsMixin";
    export default {
        name: "List",
        mixins: [ListsMixin],
        components: {
            'app-duplicates-modal': require('./DuplicatesModal').default,
        },
        data() {
            return {
                list:'',
                apiUrl: {
                    addNew: `/${list_create}`,
                },
                list_view,
                lists,
                removeDuplicatesModalActive: false,
                removeDuplicatesLoading: false,
                removeDuplicatesListId: null,
                showDuplicatesModalActive: false,
                showDuplicatesListId: null,
            }
        },
        methods: {
            triggerAction(row, action, active) {
                if (action.name === 'remove-duplicates') {
                    this.removeDuplicatesListId = row.id;
                    this.removeDuplicatesModalActive = true;
                    return;
                }
                if (action.name === 'show-duplicates') {
                    this.showDuplicatesListId = row.id;
                    this.showDuplicatesModalActive = true;
                    return;
                }
                this.getAction(row, action, active);
            },
            confirmRemoveDuplicates() {
                this.removeDuplicatesLoading = true;
                axiosPost(`${lists}/${this.removeDuplicatesListId}/remove-duplicates`).then(response => {
                    this.$toastr.s('', response.data.message);
                    this.$hub.$emit('reload-list-table');
                    this.removeDuplicatesModalActive = false;
                    this.removeDuplicatesLoading = false;
                }).catch(error => {
                    if (error.response) {
                        this.$toastr.e('', error.response.data.message);
                    }
                    this.removeDuplicatesModalActive = false;
                    this.removeDuplicatesLoading = false;
                });
            },
        },
        watch: {
            removeDuplicatesModalActive(flag) {
                if (!flag) {
                    this.removeDuplicatesListId = null;
                }
            },
            showDuplicatesModalActive(flag) {
                if (!flag) {
                    this.showDuplicatesListId = null;
                }
            }
        },
    }
</script>
